const hotel = {
  availableMealPlans: "Planos de refeições disponíveis", // translated
  availableRoomsTypes: "Tipos de quartos disponíveis", // translated
  cancellationPolicy: "Política de cancelamento", // translated
  freeCancellationAvailable: "Cancelamento gratuito disponível", // translated
  nonRefundable: "Não reembolsável", // translated
  priceFor: "preço para", // translated
  nights: "noites", // translated
  totalPrice: "Preço total", // translated
  seeAvailability: "Ver Disponibilidade", // translated
  myProfile: "Meu perfil", // translated
  travelTrust: "Confiança de viagem", // translated
  signIn: "Entrar", // translated
  searchNow: "Procure agora", // translated
  policy: "Política", // translated
  hotelName: "Nome do hotel", // translated
  beddingType: "Tipo de cama", // translated
  cxlPolicy: "Política CXL", // translated
  cxlRules: "Regras CXL", // translated
  cancellationRules: "Regras de cancelamento", // translated
  room: "sala", // translated
  maxPax: "Max Pax", // translated
  reservationDate: "Data da Reserva", // translated
};


export default hotel;
